import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://kcfsifjqgjgbjkqstsuc.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtjZnNpZmpxZ2pnYmprcXN0c3VjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzA5MTM4NDcsImV4cCI6MjA0NjQ4OTg0N30.1KXatJtvDhyVRRcKQELNCNAQD-G6WaBGVWeWCkMuOok';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);